import { Container, TitleContainer, ButtonSubmit, CancelButton, SocialWrapper } from './styles'
import CustomInput from '../Input'
import { AiOutlineLock, AiOutlineMail, AiOutlineClose } from 'react-icons/ai'
import { useRef, useCallback, useState } from 'react'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import * as Yup from 'yup'

import getValidationError from '../../utils/getValidationErrors'
import { toast } from 'react-toastify'
import { ILogin } from '../../types/login'
import { RootState } from '../../store/modules/rootReducer'

import { useDispatch, useSelector } from 'react-redux'

import { signInRequest, signFailure, signOut } from '../../store/modules/auth/actions'
import GoogleLoginComponent from '../../pages/Login/components/GoogleLogin'

const ModalLogin = () => {
  const [isOpen, setIsOpen] = useState(false)

  const formRef = useRef<FormHandles>()
  const dispatch = useDispatch()

  const { loading } = useSelector((state: RootState) => state.auth)

  const handleSignIn = useCallback(
    async (data: ILogin) => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          email: Yup.string().required('Informe o seu e-mail'),
          password: Yup.string().min(6, 'Senha deve conter pelo menos seis caracteres'),
        })

        await schema.validate(data, {
          abortEarly: false,
        })

        dispatch(signInRequest(data))
        setIsOpen(false)
      } catch (err) {
        dispatch(signFailure())
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationError(err)
          return formRef.current?.setErrors(errors)
        }

        toast.error('Algo deu errado, por favor, verifique suas credenciais')
      }
    },
    [dispatch, setIsOpen]
  )

  if (!isOpen) return null

  return (
    <Container>
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <CancelButton
            onClick={() => {
              dispatch(signOut())
              setIsOpen(false)
            }}
          >
            <AiOutlineClose />
          </CancelButton>
        </div>
        <TitleContainer>
          <h2>Sessão expirada por inatividade. Faça o login novamente.</h2>
        </TitleContainer>
        <Form ref={formRef} onSubmit={handleSignIn} autoComplete="false">
          <div className="inputEmail">
            <CustomInput name="email" placeholder="E-mail" icon={AiOutlineMail} type="email" />
          </div>
          <CustomInput
            name="password"
            placeholder="Senha"
            icon={AiOutlineLock}
            type="password"
            isPass
          />
          <button className="ForgetContainer">Esqueci minha senha</button>
          <div className="SubmitContainer">
            <ButtonSubmit type="submit" disabled={loading}>
              {loading ? 'Aguarde...' : 'Entrar'}
            </ButtonSubmit>
          </div>
          <SocialWrapper>
            <GoogleLoginComponent />
          </SocialWrapper>
        </Form>
      </div>
    </Container>
  )
}

export default ModalLogin
